<template>
  <div>
    <vue-toastr ref="toast"></vue-toastr>
    <table class="table table-bordered mb-0">
      <thead>
      <tr>
        <th>Von Kundennummer</th>
        <th>Bis Kundennummer</th>
        <th style="width: 150px;">Aktionen</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in items" :key="item.id || 'new-' + index">
        <td>
          <input v-model="item.from_number" class="form-control" type="text" />
        </td>
        <td>
          <input v-model="item.to_number" class="form-control" type="text" />
        </td>
        <td class="text-center">
          <button class="btn btn-outline btn-danger btn-sm" type="button"
                  @click="deleteItem(index)">
            <i class="fa fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <button class="btn btn-outline btn-info btn-sm mt-2" type="button" @click="addItem">
      <i class="fa fa-plus"></i> Weitere Kundennummern hinzufügen
    </button>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import axios from "axios";

export default {
  name: "SimulationExclusionsCustomer",
  components: {VueToastr},
  data() {
    return {
      items: [],
      saving: false,
    };
  },
  props: {
    variantId: {
      type: [String, Number],
      required: true,
    },
    initialItems: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.items = this.initialItems.map(item => ({
      id: item.id,
      from_number: item.from_number,
      to_number: item.to_number,
    }));
  },
  methods: {
    addItem() {
      this.items.push({
        id: null,
        from_number: "",
        to_number: "",
      });
    },
    getItems() {
      return this.items
        .filter(item => item.from_number && item.to_number)
        .map(item => ({
          id: item.id || null,
          from_number: item.from_number,
          to_number: item.to_number,
        }));
    },
    updateItems(items) {
      this.items = items.map(item => ({
        id: item.id,
        from_number: item.from_number,
        to_number: item.to_number,
      }));
    },
    deleteItem(index) {

      if (!confirm("Möchten Sie diesen Ausschluss wirklich löschen?")) {
        return;
      }

      this.items.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.table {
  margin-top: 10px;
}
.mt-2 {
  margin-top: 10px;
}
</style>
